<template>
  <div>
    <FixedButton>
      <el-button type="primary" @click.stop="addMenu" size="small">新建</el-button>
    </FixedButton>
    <CardContainer>
      <CommonForm slot="header" @search="formSearch" :form-json="formjson" />
      <MenuTable
        :width="computedWidth"
        :data="tableData"
        :operation="operation"
        @operation="handleOperation"
        :table-json="tablejson"
      >
      </MenuTable>
    </CardContainer>
    <MenuManageEdit
      :id="id"
      :type="addType"
      :pids="pids"
      v-if="visible"
      @refresh="formSearch"
      :visible.sync="visible"
    />
  </div>
</template>

<script>
import formjson from './Model/Formjson.MenuManage'
import tablejson from './Model/Tablejson.MenuManage'
import MenuManageEdit from './MenuManageEdit'
import MenuTable from './MenuTable'
// import getRoleFromPath from '@manage/mixins/getRoleFromPath'
// import { getRoleByOperationCode } from '@/authorized'
export default {
  // mixins: [getRoleFromPath],
  data() {
    return {
      formjson,
      tablejson,
      operation: [
        // {
        //   name: this.$t('additional2.up'),
        //   type: 'up',
        //   hide: () => {
        //     return !this.sortRole
        //   }
        // },
        // {
        //   name: this.$t('additional2.down'),
        //   type: 'down',
        //   hide: () => {
        //     return !this.sortRole
        //   }
        // },
        {
          name: '编辑',
          type: 'edit'
          // hide: () => {
          //   return !this.updateRole
          // }
        },
        {
          name: '添加子菜单',
          type: 'add'
          // hide: () => {
          //   return !this.addRole
          // }
        },
        {
          name: '删除菜单',
          type: 'delete'
          // hide: () => {
          //   return !this.deleteRole
          // }
        }
      ],
      tableData: [],
      queryApi: this.$api.system.menu_list,
      visible: false,
      id: '',
      pids: '',
      addType: ''
    }
  },
  computed: {
    //   /********* 权限 ***********/
    //   // this.role 计算属性通过mixins: [getRoleFromPath] 注入
    //   // 导出权限
    //   roleChildList() {
    //     return this.role.childList
    //   },
    //   // 新建的权限
    //   addRole() {
    //     let val = getRoleByOperationCode(this.roleChildList, 'add')
    //     return val ? val.isPermission === 'Y' : false
    //   },
    //   // 编辑的权限
    //   updateRole() {
    //     let val = getRoleByOperationCode(this.roleChildList, 'update')
    //     return val ? val.isPermission === 'Y' : false
    //   },
    //   // 删除的权限
    //   deleteRole() {
    //     let val = getRoleByOperationCode(this.roleChildList, 'del')
    //     return val ? val.isPermission === 'Y' : false
    //   },
    //   // 详情的权限
    //   sortRole() {
    //     let val = getRoleByOperationCode(this.roleChildList, 'sort')
    //     return val ? val.isPermission === 'Y' : false
    //   },
    //   /********* 权限 ***********/
    computedWidth() {
      return [200].filter(Boolean).reduce((pre, next) => pre + next, 0) + ''
    }
  },
  components: {
    MenuManageEdit,
    MenuTable
  },
  methods: {
    formSearch(data) {
      this.search(data, null, this.queryApi)
    },
    search(data, pageObj, api) {
      if (!data) {
        data = this.cacheData
      }
      pageObj = {
        pageSize: 999,
        pageNum: 1
      }
      this.cacheData = data
      const params = {
        ...data,
        ...pageObj
      }
      this.$store.commit('SET_TABLE_LOADING', true)
      this.$ajax
        .get(api, params)
        .then((res) => {
          this.tableData = res.data.list
          this.$nextTick(() => {
            this.$store.commit('SET_TABLE_LOADING', false)
          })
        })
        .catch(() => {
          this.tableData = []
          this.$nextTick(() => {
            this.$store.commit('SET_TABLE_LOADING', false)
          })
        })
    },
    addMenu() {
      this.id = ''
      this.addType = ''
      this.pids = ''
      this.visible = true
    },
    handleEdit(row) {
      this.id = row.id
      this.addType = ''
      this.visible = true
    },
    handleAddSubMenu(row) {
      this.id = ''
      this.pids = row.id
      this.addType = 'sub'
      this.visible = true
    },
    handleDelete(row) {
      this.$confirm('删除菜单可能会影响系统的正常使用，请在确定的情况下删除菜单.', '警告', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'danger'
      })
        .then(() => {
          let params = {
            id: row.id
          }
          this.$ajax
            .post(this.$api.system.menu_delete, params)
            .then(() => {
              this.$message.success('删除成功')
              this.formSearch(this.cacheData)
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    // 为了快捷改变一个菜单的sortnum，在某些菜单中插入一个菜单可能用到
    handleSort(row, num) {
      let params = {
        id: row.id,
        num
      }
      this.$ajax
        .post(this.$api.system.menu_sortNum_edit, params)
        .then(() => {
          this.$message.success('操作成功')
          this.formSearch(this.cacheData)
        })
        .catch(() => {})
    },
    handleOperation(data) {
      const { type, row } = data
      switch (type) {
        case 'edit':
          this.handleEdit(row)
          break
        case 'add':
          this.handleAddSubMenu(row)
          break
        case 'delete':
          this.handleDelete(row)
          break
        case 'up':
          this.handleSort(row, -1)
          break
        case 'down':
          this.handleSort(row, 1)
          break
      }
    }
  }
}
</script>
<style lang="less"></style>
